import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import './emails-section.css';
import { EMAILS_VIEWS, emailsViewFromSearch, searchWithEmailsView } from '../../../utils/emailsSubtabs';
import EmailsContainer from './EmailsContainer';
import SentEmailsContainer from '../SentEmailsComponents/SentEmailsContainer';

// The Emails tab: Campaigns (the template editor) and Sent (the archive of sent
// emails, formerly its own tab). The sub-tab is kept in ?view= so a reload or a
// shared link opens the same one; see utils/emailsSubtabs.js. Same sub-nav as
// Loyalty's Leaderboard/Prizes.
const EmailsSection = () => {
  const location = useLocation();
  const history = useHistory();
  const view = emailsViewFromSearch(location.search);

  const selectView = (next) => {
    if (next === view) return;
    history.push(`${location.pathname}${searchWithEmailsView(location.search, next)}`);
  };

  return (
    <div className="emails-section">
      <div className="subtabs" role="tablist" aria-label="Emails">
        {EMAILS_VIEWS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={view === key}
            className={`subtab${view === key ? ' on' : ''}`}
            onClick={() => selectView(key)}
          >
            {label}
          </button>
        ))}
      </div>
      {view === 'sent' ? <SentEmailsContainer /> : <EmailsContainer />}
    </div>
  );
};

export default EmailsSection;
